import { CommentIcon } from "Components/Icons/CommentIcon";
import { UserCircle } from "Components/Icons/UserCircleIcon";
import React, { useEffect, useRef } from "react";
import { Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Utils } from "../../common/utils";
import { ThinTimesIcon } from "Components/Icons/ThinTimesIcon";

interface OverrideCommentProps {
  onClick: () => void;
  isOpen: boolean;
  onClose: () => void;
  comment?: string;
  username?: string;
  date: string;
  isDisabled?: boolean
}


export const OverrideComment = ({ isOpen, comment, username, date, onClose, isDisabled, onClick }: OverrideCommentProps) => {
  const overlayRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (overlayRef.current && !overlayRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isOpen, onClose]);
  const renderCardToolTip = (props) => {
    return (
      <Tooltip {...props}>
        <Card className="override-comment-card">

          <span style={{ display: "flex", flex: 1, justifyContent: "end", padding: "6px 12px", }}>
            <ThinTimesIcon onClick={onClose} style={{ cursor: "pointer" }} />
          </span>
          <div className="details">
            <UserCircle className="user-circle-icon" />
            <div className="title-data">
              <p className="name">{username}</p>
              <p className="date">{Utils.formatDate(new Date(date), "DD/MM/YYYY - hh:mm")}</p>
            </div>
          </div>
          <p className="comment">{comment}</p>
        </Card>
      </Tooltip>
    );
  };

  return (
    <div className={"override-comment"} ref={overlayRef}>
      <OverlayTrigger trigger={"click"} show={isOpen} overlay={renderCardToolTip} rootClose onExit={onClose} >
        <span style={{ textDecoration: "underline", color: "blue", textAlign: "center"}} id="TooltipExample">
          <CommentIcon onClick={!isDisabled ? onClick : () => null} className={`override-comment-icon ${isDisabled && "disabled"}`} disabled={isDisabled} data-testid="comment-icon" />
        </span>
      </OverlayTrigger>
    </div>
  );
};